import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

const Button = ({ children, to, variant = 'primary', className, ...props }) => {
  const baseStyles = "inline-flex items-center justify-center px-8 py-3 text-sm font-medium tracking-widest uppercase transition-all duration-300 border focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-2";
  
  const variants = {
    primary: "bg-brand-500 text-white border-brand-500 hover:bg-brand-800 hover:border-brand-800",
    outline: "bg-transparent text-brand-900 border-brand-900 hover:bg-brand-900 hover:text-white",
    ghost: "bg-transparent text-brand-900 border-transparent hover:bg-brand-100"
  };

  const classes = twMerge(baseStyles, variants[variant], className);

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;